import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { LenderModel } from '../_models/lender.model';
import { ConstantsService } from './constants.service';
import 'rxjs/add/operator/map';
import { OperationsService } from './operations.service';

declare global {
  interface Window { OneSignal: any; }
}

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  public token: string;
  public account_id: string;
  public role: string;
  public lender_id: string;
  public legal_name: string;
  public platform_settings: any;

  constructor(private http: Http, private constant: ConstantsService,
    public operationsService: OperationsService) {

    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.token = currentUser && currentUser.token;
  }

  public getUserRoles(): any {
    return localStorage.getItem('roles');
  }
  getUserRights() {
    return JSON.parse(localStorage.getItem('rights'));
  }

  public canViewModule(roles: any): boolean {
    let isAllowed = false;
    const user = this.getUserRoles().split(',');
    const allowedGroups = roles.split(',');

    if (user !== null && user !== undefined) {
      try {
        if (user !== undefined && user !== null && user.length > 0) {
          try {
            user.forEach((e: any) => {
              if (allowedGroups.indexOf(e) > -1) {
                isAllowed = true;
              }
            });
          } catch (e) {
            if (allowedGroups.indexOf(user) > -1) {
              isAllowed = true;
            }
          }
        }
      } catch (e) {
        isAllowed = false;
      }
    }
    return isAllowed;
  }
  public doesUserHaveRights(roles: any): boolean {
    let isAllowed = false;
    const user = this.getUserRights();
    const allowedGroups = roles.split(',');
console.log(user.length , 'No No Nooooooooooooooo')
    if (user !== null && user !== undefined) {
      try {
        if (user !== undefined && user !== null && user.length > 0) {
          try {
            allowedGroups.forEach((e: any) => {
              if (user.indexOf(e) > -1) {
                isAllowed = true;
              }
            });
          } catch (e) {
            if (allowedGroups.indexOf(user) > -1) {
              isAllowed = true;
            }
          }
        }
      } catch (e) {
        isAllowed = false;
      }
    }
    return isAllowed;
  }
  public userHasRights(right: String): boolean {
    const userRights = this.getUserRights();
    // console.log(userRights);
    if (!userRights) return;
    let isAllowed = false;
    if (userRights.indexOf(right) > -1) {
      // console.log(right);
      isAllowed = true;
    }
    return isAllowed;
  }
  changePassword(newpassword: string, confirmpassword: string, token: string) {

    return this.http.post('https://creditclanapis.creditclan.com/api/v2/loan/changePassword',
      JSON.stringify({ newpassword: newpassword, confirmpassword: confirmpassword, token: token }));
  }

  changeSecurityQuestion(model: any, token: any): Observable<any> {
    return this.http.post('https://creditclanapis.creditclan.com/api/v2/loan/changeSecurity',
      JSON.stringify({ model: model, token: token }));
  }

  logout(): void {
    this.operationsService.logoutTheUser(
      this.token);
    // clear token remove user from local storage to log user out
    this.token = null;
    localStorage.removeItem('currentUser');
    localStorage.removeItem('token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    localStorage.removeItem('rights');
    localStorage.removeItem('is_company_staff');
    localStorage.removeItem('roles');
    localStorage.removeItem('has_remita');

    localStorage.removeItem('timeLeft');
    localStorage.removeItem('lender_activated');
    localStorage.removeItem('enable_accounting');
    localStorage.removeItem('user_id');
    localStorage.removeItem('cooperative_id');
    localStorage.removeItem('has_branches');
    localStorage.removeItem('appKey');
    localStorage.removeItem('test_mode');


    localStorage.removeItem('enable_peer_to_peer');
    localStorage.removeItem('decision_type');
    localStorage.removeItem('company_id');
    localStorage.removeItem('sample_user');
    localStorage.removeItem('platform');
    localStorage.removeItem('type_of_view'); 
    
    localStorage.removeItem('kyc_setup'); 
    localStorage.removeItem('enable_custom_narration'); 
    localStorage.removeItem('kyc_done'); 
    localStorage.removeItem('logged_in_user'); 
    localStorage.removeItem('push_to_loan_disk'); 
    
    var OneSignal = window.OneSignal || [];
    OneSignal.push(function () {
      OneSignal.deleteTag("email");
    });
    
  }

  forgot(email: any): Observable<any> {
    // get users from api
    return this.http.post('https://creditclanapis.creditclan.com/api/v2/loan/forgot', JSON.stringify({ email: email }))
      .map((response: Response) => response.json());
  }

  login(email: string, password: string): Observable<boolean> {
    return this.http.post('https://creditclanapis.creditclan.com/api/v2/loan/authenticate', JSON.stringify({
      email: email,
      password: password,
      grant_type: 'password'
    }))
      .map((response: Response) => {
        var OneSignal = window.OneSignal || [];
        OneSignal.push(function () {
          OneSignal.sendTag("email", email);
        });

        localStorage.removeItem('currentUser');
        // login successful if there's a jwt token in the response
        const token = response.json() && response.json().token;
        const account_id = response.json() && response.json().account_id;
        const role = response.json() && response.json().role;
        const legal_name = response.json() && response.json().legal_name;
        const photo = response.json() && response.json().photo;
        const icon = response.json() && response.json().icon;
        const enable_peer_to_peer = response.json() && response.json().enable_peer;
        const enable_accounting = response.json() && response.json().enable_accounting;
        const has_branches = response.json() && response.json().has_branches;
        const roles = response.json() && response.json().roles;
        const rights = response.json() && response.json().rights;
        const platform = response.json() && response.json().platform;
        const user_id = response.json() && response.json().account_id;
        const is_company_staff = response.json() && response.json().is_company_staff;
        const company_id = response.json() && response.json().company_id;
        const test_mode = response.json() && response.json().test_mode;
        const decision_type = response.json() && response.json().decision_type;
        const has_remita = response.json() && response.json().has_remita;
        const lender_activated = response.json() && response.json().lender_activated;
        const timeLeft = response.json() && response.json().timeleft;
        const appKey = response.json() && response.json().appKey;
        const kyc_setup = response.json() && response.json().kyc_setup;
        const kyc_done = response.json() && response.json().kyc_done;
        const push_to_loan_disk = response.json() && response.json().push_to_loan_disk;
        const enable_custom_narration = response.json() && response.json().enable_custom_narration; 
        const sample_user = response.json() && response.json().sample_user;

        const has_own_cloudinary = response.json() && response.json().has_own_cloudinary;
        const cloudinary_cloud_name = response.json() && response.json().cloudinary_cloud_name;
        const cloudinary_version = response.json() && response.json().website_logo;
        const showoff = response.json() && response.json().showoff;
        const logged_in_user = response.json() && response.json().logged_in_user;
        if (token) {
          // set token property
          this.token = token;
          this.account_id = account_id;
          this.role = role;
          this.legal_name = legal_name;
          // store username and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('currentUser', JSON.stringify({
            is_company_staff: is_company_staff,
            company_id: company_id,
            photo: photo,
            email: email,
            token: token,
            role: role,
            account_id: account_id,
            legal_name: legal_name,
            icon: icon,
            platform: platform,
            rights: rights,
            kyc_setup:kyc_setup,
            enable_custom_narration:enable_custom_narration,
            push_to_loan_disk:push_to_loan_disk,
            cloudinary_cloud_name:cloudinary_cloud_name,
            has_own_cloudinary:has_own_cloudinary,
            cloudinary_version:cloudinary_version,
            showoff:showoff
          }));
          localStorage.setItem('logged_in_user', JSON.stringify(logged_in_user));
          localStorage.setItem('sample_user', JSON.stringify(sample_user));
          localStorage.setItem('token', token);
          localStorage.setItem('id_token', token);
          localStorage.setItem('enable_peer_to_peer', enable_peer_to_peer);
          localStorage.setItem('enable_accounting', enable_accounting);
          localStorage.setItem('roles', roles);
          localStorage.setItem('rights', JSON.stringify(rights));
          localStorage.setItem('platform', platform);
          localStorage.setItem('user_id', user_id);
          localStorage.setItem('kyc_done', kyc_done);
          localStorage.setItem('is_company_staff', is_company_staff);
          localStorage.setItem('company_id', company_id);
          localStorage.setItem('cooperative_id', '0');
          localStorage.setItem('test_mode', test_mode);
          localStorage.setItem('lender_activated', lender_activated);
          localStorage.setItem('has_remita', has_remita);
          localStorage.setItem('decision_type', decision_type);
          localStorage.setItem('timeLeft', timeLeft);
          localStorage.setItem('appKey', appKey);
          localStorage.setItem('has_branches', has_branches);
          localStorage.setItem('push_to_loan_disk', push_to_loan_disk);
          const type_of_view = localStorage.getItem('type_of_view');
          if (!type_of_view) {
            localStorage.setItem('type_of_view', '1');
          }
          const expiresAt = JSON.stringify((60 * 60 * 1000) + Date.now());
          localStorage.setItem('expires_at', expiresAt);
          // return true to indicate successful login
          return true;
        } else {
          // return false to indicate failed login
          return false;
        }
      });
  }

  serializeParams(obj) {
    let str = '';
    for (var key in obj) {
      if (str != '') {
        str += '&';
      }
      str += key + '=' + obj[key];
    }
    return str;
  }
  confirmOTP(token: any, otp: any): Observable<any> {
    // get users from api
    return this.http.post('https://creditclanapis.creditclan.com/api/v2/employee/confirm_otp', JSON.stringify({ token: token, otp: otp }))
      .map((response: Response) => response.json());
  }
  signup_(lender: LenderModel): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    let options = new RequestOptions({ headers: headers });
    return this.http.post('https://creditclanapis.creditclan.com/api/v2/onboard', this.serializeParams(lender), options)
      .map((response: Response) => {
        localStorage.removeItem('currentUser');
        // login successful if there's a jwt token in the response
        let status = response.json() && response.json().status;
        if (status === false) {
          return response.json();
        } else {
          let token = response.json() && response.json().token;
          let account_id = response.json() && response.json().account_id;
          let role = response.json() && response.json().role;
          let photo = response.json() && response.json().photo;
          let enable_peer_to_peer = response.json() && response.json().enable_peer;
          let enable_accounting = response.json() && response.json().enable_accounting;
          let icon = response.json() && response.json().icon;
          if (token) {
            // set token property
            this.token = token;
            this.account_id = account_id;
            this.role = role;
            this.legal_name = lender.LEGAL_NAME;
            // store username and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify({
              icon: icon,
              photo: photo,
              email: lender.EMAIL,
              token: token,
              role: role,
              account_id: account_id,
              legal_name: lender.LEGAL_NAME
            }));
            localStorage.setItem('token', token);
            localStorage.setItem('id_token', token);
            localStorage.setItem('enable_peer_to_peer', enable_peer_to_peer);
            localStorage.setItem('enable_accounting', enable_accounting);
            let type_of_view = localStorage.getItem('type_of_view');
            if (!type_of_view) {
              localStorage.setItem('type_of_view', '1');
            }
            const expiresAt = JSON.stringify((60 * 60 * 1000) + Date.now());
            localStorage.setItem('expires_at', expiresAt);
            // return true to indicate successful login
            return response.json();
          } else {
            // return false to indicate failed login
            return response.json();
          }
        }

      });
  }

  signup(lender: any): Observable<any> {

    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    const options = new RequestOptions({ headers: headers });
    return this.http.post('https://creditclanapis.creditclan.com/api/v2/onboard', this.serializeParams(lender), options)
      .map((response: Response) => {
        localStorage.removeItem('currentUser');
        // login successful if there's a jwt token in the response
        let status = response.json() && response.json().status;
        if (status === false) {
          return response.json();
        } else {
          let token = response.json() && response.json().token;
          let account_id = response.json() && response.json().account_id;
          let role = response.json() && response.json().role;
          let photo = response.json() && response.json().photo;
          let enable_peer_to_peer = response.json() && response.json().enable_peer;
          let enable_accounting = response.json() && response.json().enable_accounting;
          let icon = response.json() && response.json().icon;
          if (token) {
            // set token property
            this.token = token;
            this.account_id = account_id;
            this.role = role;
            this.legal_name = lender.LEGAL_NAME;
            // store username and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify({
              icon: icon,
              photo: photo,
              email: lender.EMAIL,
              token: token,
              role: role,
              account_id: account_id,
              legal_name: lender.LEGAL_NAME
            }));
            localStorage.setItem('token', token);
            localStorage.setItem('id_token', token);
            localStorage.setItem('enable_peer_to_peer', enable_peer_to_peer);
            localStorage.setItem('enable_accounting', enable_accounting);
            let type_of_view = localStorage.getItem('type_of_view');
            if (!type_of_view) {
              localStorage.setItem('type_of_view', '1');
            }
            const expiresAt = JSON.stringify((60 * 60 * 1000) + Date.now());
            localStorage.setItem('expires_at', expiresAt);
            // return true to indicate successful login
            return response.json();
          } else {
            // return false to indicate failed login
            return response.json();
          }
        }

      });

  }

  submitSetup(setup) {
    return this.http.post('https://creditclanapis.creditclan.com/api/v2/loan/setup', {
      setup
    }).map(res => res.json());
  }
  goLiveNow(token: any, go_live_details: any) {
    return this.http.post(`${this.constant.read('api_base')}onboard/golive`, { token: token, go_live_details: go_live_details }).map(res => res.json());
  }
  authorize(token:any): Observable<boolean> {
    return this.http.post('https://creditclanapis.creditclan.com/api/v2/loan/authorize', JSON.stringify({
      token: token
    }))
      .map((response: Response) => {
        

        localStorage.removeItem('currentUser');
        // login successful if there's a jwt token in the response
        const token = response.json() && response.json().token;
        const account_id = response.json() && response.json().account_id;
        const email = response.json() && response.json().email;
        const role = response.json() && response.json().role;
        const legal_name = response.json() && response.json().legal_name;
        const photo = response.json() && response.json().photo;
        const icon = response.json() && response.json().icon;
        const enable_peer_to_peer = response.json() && response.json().enable_peer;
        const enable_accounting = response.json() && response.json().enable_accounting;
        const has_branches = response.json() && response.json().has_branches;
        const roles = response.json() && response.json().roles;
        const rights = response.json() && response.json().rights;
        const platform = response.json() && response.json().platform;
        const user_id = response.json() && response.json().account_id;
        const is_company_staff = response.json() && response.json().is_company_staff;
        const company_id = response.json() && response.json().company_id;
        const test_mode = response.json() && response.json().test_mode;
        const decision_type = response.json() && response.json().decision_type;
        const has_remita = response.json() && response.json().has_remita;
        const lender_activated = response.json() && response.json().lender_activated;
        const timeLeft = response.json() && response.json().timeleft;
        const appKey = response.json() && response.json().appKey;
        const kyc_setup = response.json() && response.json().kyc_setup;
        const sample_user = response.json() && response.json().sample_user;
        if (token) {
          // set token property
          this.token = token;
          this.account_id = account_id;
          this.role = role;
          this.legal_name = legal_name;
          // store username and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('currentUser', JSON.stringify({
            is_company_staff: is_company_staff,
            company_id: company_id,
            photo: photo,
            email: email,
            token: token,
            role: role,
            account_id: account_id,
            legal_name: legal_name,
            icon: icon,
            platform: platform,
            rights: rights,
            kyc_setup:kyc_setup
          }));
          localStorage.setItem('sample_user', JSON.stringify(sample_user));
          localStorage.setItem('token', token);
          localStorage.setItem('id_token', token);
          localStorage.setItem('enable_peer_to_peer', enable_peer_to_peer);
          localStorage.setItem('enable_accounting', enable_accounting);
          localStorage.setItem('roles', roles);
          localStorage.setItem('rights', JSON.stringify(rights));
          localStorage.setItem('platform', platform);
          localStorage.setItem('user_id', user_id);
          localStorage.setItem('is_company_staff', is_company_staff);
          localStorage.setItem('company_id', company_id);
          localStorage.setItem('cooperative_id', '0');
          localStorage.setItem('test_mode', test_mode);
          localStorage.setItem('lender_activated', lender_activated);
          localStorage.setItem('has_remita', has_remita);
          localStorage.setItem('decision_type', decision_type);
          localStorage.setItem('timeLeft', timeLeft);
          localStorage.setItem('appKey', appKey);
          localStorage.setItem('has_branches', has_branches);
          const type_of_view = localStorage.getItem('type_of_view');
          if (!type_of_view) {
            localStorage.setItem('type_of_view', '1');
          }
          const expiresAt = JSON.stringify((60 * 60 * 1000) + Date.now());
          localStorage.setItem('expires_at', expiresAt);
          // return true to indicate successful login
          return true;
        } else {
          // return false to indicate failed login
          return false;
        }
      });
  }
}
